import { render, staticRenderFns } from "./CustomVideo.vue?vue&type=template&id=30ea5168&scoped=true&"
import script from "./CustomVideo.vue?vue&type=script&lang=js&"
export * from "./CustomVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ea5168",
  null
  
)

export default component.exports